import { GuidedStep } from '@cpd-app/core-module/models';

export const GUIDED_STEP: GuidedStep[] = [
  {
    title: 'Take All 4 Surveys',
    number: 1
  },
  {
    title: 'Set Career Goal',
    number: 2
  },
  {
    title: 'Set Academic Goal',
    number: 3
  },
  {
    title: 'Save Return Link',
    number: 4
  }
];
